export const NOTICES = [
  { value: "MPr-2025-7", label: "MPr-2025-7 | Inovação Produtiva - RCI" },
  {
    value: "MPr-2026-6",
    label:
      "MPr-2026-6 | SICE - Inovação Produtiva - Territórios de Baixa Densidade e Outros Territórios",
  },
  {
    value: "MPr-2026-10",
    label: "MPr-2026-10 | STEP - Inovação Produtiva - Digital e Biotecnologia",
  },
  {
    value: "COMPETE2030-2026-12",
    label: "COMPETE2030-2026-12 | STEP - Inovação Produtiva - Energia",
  },
  {
    value: "06/C05-i14.01/2026",
    label: "06/C05-i14.01/2026 | Inovação Empresarial",
  },
];

export const convertJsonData = (toConvert) => {
  if (Array.isArray(toConvert)) {
    return toConvert.map((v) => ({ _id: v.value, label: v.label }));
  }

  return Object.entries(toConvert).reduce((acc, [k, arr]) => {
    acc[k] = arr.map((v) => ({ _id: v.value, label: v.label }));
    return acc;
  }, {});
};
